import React, { useState } from 'react';
import { mutate } from '../shared/api';

/** „Zaboravili ste lozinku?" — traži email, šalje reset link. */
export function ForgotPasswordForm({ onBackToLogin }: { onBackToLogin: () => void }) {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');

    async function submit(e: React.FormEvent) {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            await mutate('/forgot-password', null, 'POST', { email });
            setDone(true);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Greška.');
        } finally {
            setBusy(false);
        }
    }

    if (done) {
        return (
            <div className="card auth-card">
                <p className="eyebrow">Reset lozinke</p>
                <h2>Provjeri email 📧</h2>
                <p className="lead">
                    Ako račun s emailom <strong>{email}</strong> postoji, poslali smo upute za
                    postavljanje nove lozinke. Link vrijedi 60 minuta.
                </p>
                <button type="button" onClick={onBackToLogin}>Natrag na prijavu</button>
            </div>
        );
    }

    return (
        <form className="card auth-card" onSubmit={submit}>
            <p className="eyebrow">Reset lozinke</p>
            <h2>Zaboravljena lozinka</h2>
            <p className="lead" style={{ fontSize: '0.92rem' }}>
                Upiši email računa i poslat ćemo ti link za postavljanje nove lozinke.
            </p>
            <label>Email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required /></label>
            <button type="submit" disabled={busy}>{busy ? 'Šaljem…' : 'Pošalji link za reset'}</button>
            <button type="button" className="secondary" onClick={onBackToLogin} style={{ marginTop: 8 }}>
                Natrag na prijavu
            </button>
            <p className="error">{error}</p>
        </form>
    );
}

/** Postavljanje nove lozinke pomoću tokena iz emaila (link sadrži ?reset_token & ?reset_email). */
export function ResetPasswordForm({
    token,
    email,
    onDone,
}: {
    token: string;
    email: string;
    onDone: () => void;
}) {
    const [pwd, setPwd] = useState('');
    const [pwd2, setPwd2] = useState('');
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState('');

    async function submit(e: React.FormEvent) {
        e.preventDefault();
        setError('');
        if (pwd !== pwd2) {
            setError('Lozinke se ne podudaraju.');
            return;
        }
        if (pwd.length < 10) {
            setError('Lozinka mora imati barem 10 znakova.');
            return;
        }
        setBusy(true);
        try {
            await mutate('/reset-password', null, 'POST', {
                email,
                token,
                password: pwd,
                password_confirmation: pwd2,
            });
            setDone(true);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Greška.');
        } finally {
            setBusy(false);
        }
    }

    if (done) {
        return (
            <div className="card auth-card">
                <p className="eyebrow">Reset lozinke</p>
                <h2>Gotovo! ✅</h2>
                <p className="lead">Lozinka je promijenjena. Možeš se prijaviti s novom lozinkom.</p>
                <button type="button" onClick={onDone}>Prijavi se</button>
            </div>
        );
    }

    return (
        <form className="card auth-card" onSubmit={submit}>
            <p className="eyebrow">Reset lozinke</p>
            <h2>Nova lozinka</h2>
            <p className="lead" style={{ fontSize: '0.92rem' }}>
                Postavljaš novu lozinku za <strong>{email}</strong>.
            </p>
            <label>Nova lozinka<input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} autoComplete="new-password" required /></label>
            <label>Ponovi lozinku<input type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} autoComplete="new-password" required /></label>
            <button type="submit" disabled={busy}>{busy ? 'Spremam…' : 'Postavi lozinku'}</button>
            <button type="button" className="secondary" onClick={onDone} style={{ marginTop: 8 }}>
                Natrag na prijavu
            </button>
            <p className="error">{error}</p>
        </form>
    );
}
